import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ spacing }) => ({
  text: {
    color: blueGrey[500],
    fontSize: "0.6875rem"
  },
  chipContainer: {
    position: "absolute",
    right: 0,
    top: "-2px",
    display: "flex",
    justifyContent: "flex-end"
  }
}))
